/* Force ~90% "zoomed-out" feel on desktop.
   - Chrome/Edge/Safari: use native zoom
   - Firefox: add a class so CSS fallback can scale safely */
(function () {
  const MIN = 1024; // desktop breakpoint
  function isDesktop() { return window.innerWidth >= MIN; }

  function applyZoom() {
    const ua = navigator.userAgent.toLowerCase();
    const isFirefox = ua.includes('firefox');

    if (isDesktop()) {
      if (isFirefox) {
        // Use CSS transform fallback
        document.documentElement.classList.add('ff-scale');
        // Clear native zoom if previously set
        document.documentElement.style.zoom = '';
      } else {
        // Use native zoom (cleanest result)
        document.documentElement.classList.remove('ff-scale');
        document.documentElement.style.zoom = '0.9';
      }
    } else {
      // Below desktop: no zoom
      document.documentElement.classList.remove('ff-scale');
      document.documentElement.style.zoom = '';
    }
  }

  window.addEventListener('resize', applyZoom);
  document.addEventListener('DOMContentLoaded', applyZoom);
  applyZoom(); // run once on load
})();